import { useState } from 'react'
import { Trans } from 'react-i18next'

import { Excel } from '@makyoapp/makyo-icon/colored'
import { ChevronRight, Upload16 } from '@makyoapp/makyo-icon/icon'
import { Spreadsheet } from '@makyoapp/makyo-icon/mimetype'
import { DD, useTheme } from '@makyoapp/makyo-ui'

import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { useGridImportData } from '@/hooks/useGridImportData'

/**
 * @todo handle import state
 */
export function AppendData() {
  const { dbId } = useDbClientContext()
  const { startImport } = useGridImportData()

  const { state: themeState } = useTheme()
  const [show, setShow] = useState(false)

  const handleStartImport = (fileType: 'csv' | 'excel') => {
    startImport(dbId as string, fileType, 'append')
  }

  return (
    <DD
      show={show}
      onToggle={() => setShow(!show)}
      className='w-full'
      toggleClassName='mk-ddi mk-dd-row flex-c w-full'
      menuClassName='mk-dd-menu border bdr py-2 w-[220px]'
      toggle={() => {
        return (
          <div className='flex-c w-full'>
            <div className='flex-c w-full'>
              <Upload16 />
              <div>
                <Trans>Append Data</Trans>
              </div>
            </div>
            <ChevronRight />
          </div>
        )
      }}
      placement={themeState.dir === 'rtl' ? 'left' : 'right'}
    >
      <button
        onClick={() => {
          setShow(false)
          handleStartImport('csv')
        }}
        className='mk-ddi flex-c mk-dd-row'
      >
        <Spreadsheet width={16} height={16} />
        <div>
          <Trans>CSV File</Trans>
        </div>
      </button>
      <button
        onClick={() => {
          setShow(false)
          handleStartImport('excel')
        }}
        className='mk-ddi flex-c mk-dd-row'
      >
        <Excel width={16} height={16} />
        <div>
          <Trans>Microsoft Excel</Trans>
        </div>
      </button>
    </DD>
  )
}
